'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { media } from '../../mixins/media.js';
import '../../mixins/keyboardFocus.js';
import '../../mixins/markStyle.js';
import '../../mixins/scrollbarStyle.js';
import { spacing } from '../../mixins/spacing.js';
import '../../mixins/textStyle.js';
import { ContentWrapper } from '../ContentWrapper/ContentWrapper.js';
import { Flex } from '../Flex/Flex.js';
import { IconButton } from '../IconButton/IconButton.js';
import { List } from '../List/List.js';
import { ListItem } from '../List/ListItem.js';
import { ListLinkItem } from '../List/ListLinkItem.js';
import { Logo, LogoELS } from '../Logo/Logo.js';
import { Text } from '../Text/Text.js';

const StyledTop = styled(Flex).withConfig({
  componentId: "sc-4n3g7t-0"
})(["background-color:", ";"], ({
  theme
}) => theme.components.footer.top.backgroundColor);
const StyledMiddle = styled(Flex).withConfig({
  componentId: "sc-4n3g7t-1"
})(["background-color:", ";"], ({
  theme
}) => theme.components.footer.middle.backgroundColor);
const StyledBottom = styled(Flex).withConfig({
  componentId: "sc-4n3g7t-2"
})(["background-color:", ";align-items:center;"], ({
  theme
}) => theme.components.footer.bottom.backgroundColor);
const StyledLinkMiddle = styled(ListLinkItem).withConfig({
  componentId: "sc-4n3g7t-3"
})(["color:", ";", " &:hover{color:", ";}"], ({
  theme
}) => theme.components.footer.middle.linkColor, defaultStyles.ellipsis, ({
  theme
}) => theme.components.footer.middle.linkColorHover);
const StyledLinkBottom = styled(ListLinkItem).withConfig({
  componentId: "sc-4n3g7t-4"
})(["color:", ";&:hover{color:", ";}"], ({
  theme
}) => theme.components.footer.bottom.linkColor, ({
  theme
}) => theme.components.footer.bottom.linkColorHover);
const Wrapper = styled(ContentWrapper).withConfig({
  componentId: "sc-4n3g7t-5"
})(["display:flex;justify-content:space-between;padding-top:", ";padding-bottom:", ";flex-direction:column;align-items:flex-start;", ""], spacing(6), spacing(6), media.greaterThan('s')`
    flex-direction: row;
    align-items: center;
    gap: ${spacing(4)};
  `);
const WrapperBottom = styled(Wrapper).withConfig({
  componentId: "sc-4n3g7t-6"
})(["flex-direction:column-reverse;", ""], media.greaterThan('s')`
    flex-direction: row;
    align-items: center;
  `);
const LogoWrapper = styled(Flex).withConfig({
  componentId: "sc-4n3g7t-7"
})(["margin-bottom:", ";", ""], spacing(8), media.greaterThan('s')`
    margin-bottom: 0;
  `);
const StyledIconButton = styled(IconButton).withConfig({
  componentId: "sc-4n3g7t-8"
})(["color:", ";"], ({
  theme
}) => theme.components.footer.middle.linkColor);
const Footer = /*#__PURE__*/withTitan(({
  breadcrumb,
  className,
  copyright = `Sdu © ${new Date().getFullYear()}`,
  links,
  logos = [jsx(Logo, {
    size: 48
  }, "sdu"), jsx(LogoELS, {}, "els")],
  maxContentWidth,
  px = 6,
  testId = 'footer'
}) => {
  return jsxs("footer", {
    className: className,
    "data-test-id": testId,
    children: [breadcrumb && jsx(StyledTop, {
      children: jsx(Wrapper, {
        maxWidth: maxContentWidth,
        px: px,
        children: breadcrumb
      })
    }), jsx(StyledMiddle, {
      children: jsxs(Wrapper, {
        maxWidth: maxContentWidth,
        px: px,
        children: [jsx(LogoWrapper, {
          gap: 4,
          children: logos.slice(0, Math.min(2, logos.length))
        }), jsxs(Flex, {
          flexDirection: {
            xs: 'column',
            s: 'row'
          },
          flexWrap: {
            xs: 'wrap',
            s: 'nowrap'
          },
          gap: {
            xs: 4,
            m: 8
          },
          children: [(links === null || links === void 0 ? void 0 : links.middle) && jsx(List, {
            spaceAfter: 0,
            spaceBetween: {
              xs: 2,
              s: 4,
              m: 6
            },
            variant: {
              xs: 'vertical-start',
              s: 'horizontal-start'
            },
            children: links.middle.map(_a => {
              var {
                  label,
                  to
                } = _a,
                rest = __rest(_a, ["label", "to"]);
              return jsx(StyledLinkMiddle, Object.assign({
                linkTo: to
              }, rest, {
                children: label
              }), label);
            })
          }), (links === null || links === void 0 ? void 0 : links.socials) && jsx(List, {
            spaceAfter: 0,
            spaceBetween: {
              xs: 2,
              m: 4
            },
            variant: "horizontal-start",
            children: links.socials.map(props => jsx(ListItem, {
              children: jsx(StyledIconButton, Object.assign({}, props, {
                size: 20
              }))
            }, props.href))
          })]
        })]
      })
    }), jsx(StyledBottom, {
      children: jsxs(WrapperBottom, {
        maxWidth: maxContentWidth,
        px: px,
        children: [jsx(Text, {
          color: "grey0",
          type: "label",
          children: copyright
        }), (links === null || links === void 0 ? void 0 : links.bottom) && jsx(List, {
          spaceAfter: {
            xs: 6,
            s: 0
          },
          variant: {
            xs: 'vertical-start',
            s: 'horizontal-start'
          },
          children: links.bottom.map(_a => {
            var {
                label,
                to
              } = _a,
              rest = __rest(_a, ["label", "to"]);
            return jsx(StyledLinkBottom, Object.assign({
              linkTo: to
            }, rest, {
              children: label
            }), label);
          })
        })]
      })
    })]
  });
}, {
  name: 'Footer'
});

export { Footer };
//# sourceMappingURL=Footer.js.map
